export default __webpack_public_path__ + "static/media/5.185d69a0.png";